import { mount } from 'svelte';
import '../styles/global.css';
import App from './App.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('#app not found');

export default mount(App, { target });
